var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
// Can Support Service Workers Interface
OCS.Interfaces.CSServiceWorkers = {
    service_worker_support: true,
    service_worker: null,
    create_service_worker: function (request_info) {
        if (!request_info.path || this.is_active_full_service_worker()) {
            return false;
        }
        var path = request_info.path;

        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug('Worker Manager: Creating a new worker. ', path);
        }
        var worker = new OCS.Classes.ServiceWorkerHandler({'path': path});
        worker.addEvent(worker.options.events.worker_online, this.bound_methods.on_worker_online);
        worker.addEvent(worker.options.events.worker_status_update, this.bound_methods.on_worker_status_update);
        worker.addEvent(worker.options.events.worker_terminated, this.bound_methods.on_worker_terminated);
        if (request_info.init_msg || request_info.msg || request_info.msg_queue) {
            worker.set_active_request(request_info);
        }
        this.service_worker = worker;
        return worker;
    },    
    register_service_worker: function (request_info) {
        if (request_info === null || typeof request_info !== "object" || !Object.keys(request_info).length) {
            return false;
        }
        if (!request_info.path) {
            return false;
        }
        var path = request_info.path;
        if (!this.is_active_full_service_worker()) {
            return this.create_service_worker(request_info);
        }
        return false;
    },
    is_active_full_service_worker: function () {
        if (this.service_worker) {
            return true;
        } else {
            return false;
        }
    },
};